import { render } from "./DistAdminRegisteration.vue?vue&type=template&id=ed2bd98a&ts=true"
import script from "./DistAdminRegisteration.vue?vue&type=script&setup=true&lang=ts"
export * from "./DistAdminRegisteration.vue?vue&type=script&setup=true&lang=ts"

import "./DistAdminRegisteration.vue?vue&type=style&index=0&id=ed2bd98a&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scan/admin/DistAdminRegisteration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed2bd98a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed2bd98a', __exports__)) {
    console.log('reload')
    api.reload('ed2bd98a', __exports__)
  }
  
  module.hot.accept("./DistAdminRegisteration.vue?vue&type=template&id=ed2bd98a&ts=true", () => {
    console.log('re-render')
    api.rerender('ed2bd98a', render)
  })

}


export default __exports__